import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { DocumentManualVerificationViewModel } from './DocumentManualVerificationViewModel'
import Button from 'components/Button'
import styles from './DocumentManualVerificationModal.sass'
import { observer } from 'mobx-react'

interface DocumentManualVerificationModalProps {
  vm: DocumentManualVerificationViewModel
}

export default observer(function DocumentManualVerificationModal({
  vm,
}: DocumentManualVerificationModalProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_documents.svg')}
          />
          <ModalSheetContentTitle>
            Are you sure this is the right file?
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            {vm.isMissingProSignature ? (
              <>
                The preparer&apos;s{' '}
                <strong className={styles.bold}>signature</strong> appears to be
                missing from this final return, which needs to be mailed. Are
                you sure this is the right file?
              </>
            ) : (
              <>
                The <strong className={styles.bold}>name</strong> on this
                document does not appear to match the expected client. Are you
                sure this is the right file?
              </>
            )}
          </ModalSheetContentDescription>

          <div className={styles.viewDocument}>
            <Button
              type={vm.hasViewedDocument ? 'secondary' : 'primary'}
              onClick={vm.viewDocument}
            >
              View Document
            </Button>
          </div>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer>
          {!vm.hasViewedDocument && (
            <div className={styles.viewHint}>
              View the document before confirming or deleting.
            </div>
          )}
        </ModalSheetFooterSpacer>
        <ModalSheetFooterButtonGroup>
          <Button
            type="primary"
            disabled={!vm.hasViewedDocument}
            onClick={vm.confirmDocument}
          >
            Yes, it's the right file
          </Button>
          <Button
            type="danger"
            disabled={!vm.hasViewedDocument}
            onClick={vm.deleteDocument}
          >
            No, delete it
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
